function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "feedback");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(-32.000000, -656.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy-2",
  transform: "translate(10.000000, 639.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "feedback",
  transform: "translate(23.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19,8.66997237 C18.805724,3.70396516 14.5566793,-0.171225717 9.5,0.0058335872 C4.44332071,-0.171225717 0.194275969,3.70396516 0,8.66997237 C0.194275969,13.6359796 4.44332071,17.5111704 9.5,17.3341111 C10.1513423,17.3339297 10.8011848,17.2727822 11.4407143,17.1514978 L16.2857143,20 L16.2857143,14.6682223 C17.9480289,13.0900435 18.9212242,10.9393972 19,8.66997237 Z",
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.5,
  y1: 4,
  x2: 9.5,
  y2: 9,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5,11 C8.94771525,11 8.5,11.4477153 8.5,12 C8.5,12.5522847 8.94771525,13 9.5,13 C10.0522847,13 10.5,12.5522847 10.5,12 C10.5,11.4477153 10.0522847,11 9.5,11 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})))));

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.242a8289.svg";
export { ForwardRef as ReactComponent };